/**
 * As unidades da federação.
 *
 * Mora aqui, e não no admin, porque as duas pontas de Provas para Imprimir
 * precisam da mesma lista: o cadastro escolhe a UF da prova e o site escreve
 * "São Paulo" onde a API devolveu "SP". Duas cópias divergiriam no dia em que
 * alguém corrigisse um nome só de um lado.
 *
 * **Sigla e nome, e não só a sigla.** No filtro do site cabe a sigla, mas no
 * título da página cabe o nome - "Provas de cartório de Minas Gerais" é o que
 * alguém digita no buscador, e "Provas de MG" não é.
 */
export interface Estado {
  uf: string;
  nome: string;
}

export const ESTADOS: readonly Estado[] = [
  { uf: 'AC', nome: 'Acre' },
  { uf: 'AL', nome: 'Alagoas' },
  { uf: 'AM', nome: 'Amazonas' },
  { uf: 'AP', nome: 'Amapá' },
  { uf: 'BA', nome: 'Bahia' },
  { uf: 'CE', nome: 'Ceará' },
  { uf: 'DF', nome: 'Distrito Federal' },
  { uf: 'ES', nome: 'Espírito Santo' },
  { uf: 'GO', nome: 'Goiás' },
  { uf: 'MA', nome: 'Maranhão' },
  { uf: 'MG', nome: 'Minas Gerais' },
  { uf: 'MS', nome: 'Mato Grosso do Sul' },
  { uf: 'MT', nome: 'Mato Grosso' },
  { uf: 'PA', nome: 'Pará' },
  { uf: 'PB', nome: 'Paraíba' },
  { uf: 'PE', nome: 'Pernambuco' },
  { uf: 'PI', nome: 'Piauí' },
  { uf: 'PR', nome: 'Paraná' },
  { uf: 'RJ', nome: 'Rio de Janeiro' },
  { uf: 'RN', nome: 'Rio Grande do Norte' },
  { uf: 'RO', nome: 'Rondônia' },
  { uf: 'RR', nome: 'Roraima' },
  { uf: 'RS', nome: 'Rio Grande do Sul' },
  { uf: 'SC', nome: 'Santa Catarina' },
  { uf: 'SE', nome: 'Sergipe' },
  { uf: 'SP', nome: 'São Paulo' },
  { uf: 'TO', nome: 'Tocantins' },
];

const POR_UF = new Map(ESTADOS.map((estado) => [estado.uf, estado.nome]));

/**
 * O nome do estado, ou a própria sigla quando ela não é uma UF conhecida.
 *
 * Devolver a sigla é melhor do que devolver vazio: se um dia entrar lixo na
 * coluna, a tela mostra o lixo em vez de fingir que a prova não tem estado.
 */
export const nomeDoEstado = (uf: string | null | undefined): string =>
  uf ? (POR_UF.get(uf) ?? uf) : '';
